import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MinuteApprovalRuleMinDTO, MinuteRequestApprovalRuleDetailDTO } from '../interfaces/minute-request-approval-rule.interface';
import { environment } from 'src/environments/enviroments';
import { AddUpdateApprovalMinuteConditionDTO, MinuteRequestApprovalRuleConditionDTO, RegisterMinuteRequestApprovalRuleDTO, RemoveMinuteRequestApprovalConditionRequestDTO, UpdateMinuteApprovalConditionRequest, UpdateMinuteRequestApprovalRuleDTO } from '../interfaces/minute-request-approval-rule-manage.interface';
import { ActionResponseDTO } from 'src/app/common/interfaces/action-result.interface';
import { MinuteApprovalParameterDTO } from '../interfaces/minue-request-approval-paramters.interface';

@Injectable({
  providedIn: 'root'
})
export class MinuteRequestApprovalRuleService {

  constructor(private httpClient: HttpClient) { }

  public getAllMinuteRequestApprovalRules(): Observable<MinuteApprovalRuleMinDTO[]>{
    const endpoint = `${environment.apiUrl}/MinuteApprovalRules`;
    return this.httpClient.get<MinuteApprovalRuleMinDTO[]>(endpoint);
  }

  public getMinuteRequestApprovalRule(minuteRequestApprovalRuleId: number): Observable<MinuteRequestApprovalRuleDetailDTO> {
    const endpoint = `${environment.apiUrl}/MinuteApprovalRules/${minuteRequestApprovalRuleId}`;
    return this.httpClient.get<MinuteRequestApprovalRuleDetailDTO>(endpoint);
  }

  registerNewMinuteRequestApprovalRule(request: RegisterMinuteRequestApprovalRuleDTO): Observable<ActionResponseDTO<MinuteApprovalRuleMinDTO>>{
    const endpoint = `${environment.apiUrl}/MinuteApprovalRules`;
    return this.httpClient.post<ActionResponseDTO<MinuteApprovalRuleMinDTO>>(endpoint, request);
  }

  /**
   * Metodo que envia la solicitud de modificar los datos de una regla de aprobación de minuta
   * @param minuteRequestApprovalRuleId Id de regla de aprobacion de minuta
   * @param request Solicitud con los nuevos datos de la regla de aprobación
   * @returns Observable que entrega el resultado de la operación, junto con la entidad actualizada
   */
  updateMinuteRequestApprovalRule(minuteRequestApprovalRuleId: number, request: UpdateMinuteRequestApprovalRuleDTO): Observable<ActionResponseDTO<MinuteApprovalRuleMinDTO>>{
    const endpoint = `${environment.apiUrl}/MinuteApprovalRules/${minuteRequestApprovalRuleId}`;
    return this.httpClient.put<ActionResponseDTO<MinuteApprovalRuleMinDTO>>(endpoint, request);
  }

  public removeMinuteRequestApprovalRuleCondition(request: RemoveMinuteRequestApprovalConditionRequestDTO): Observable<ActionResponseDTO<number>> {
    const endpoint = `${environment.apiUrl}/MinuteApprovalRules/${request.minuteRequestRuleId}/conditions/${request.minuteRequestConditionId}`;
    return this.httpClient.delete<ActionResponseDTO<number>>(endpoint);
  }

  public enableMinuteRequestApprovalRule(minuteRequestApprovalRuleId: number): Observable<ActionResponseDTO<MinuteApprovalRuleMinDTO>>{
    const endpoint = `${environment.apiUrl}/MinuteApprovalRules/${minuteRequestApprovalRuleId}/enable`;
    return this.httpClient.put<ActionResponseDTO<MinuteApprovalRuleMinDTO>>(endpoint, null);
  }

  public disableMinuteRequestApprovalRule(minuteRequestApprovalRuleId: number): Observable<ActionResponseDTO<MinuteApprovalRuleMinDTO>>{
    const endpoint = `${environment.apiUrl}/MinuteApprovalRules/${minuteRequestApprovalRuleId}/disable`;
    return this.httpClient.put<ActionResponseDTO<MinuteApprovalRuleMinDTO>>(endpoint, null);
  }

  public getAllMinuteApprovalParameters(): Observable<MinuteApprovalParameterDTO[]>{
    const endpoint = `${environment.apiUrl}/MinuteApprovalRules/parameters`;
    return this.httpClient.get<MinuteApprovalParameterDTO[]>(endpoint);
  }

  public updateMinuteApprovalCondition(minuteRequestApprovalRuleId: number, minuteRequestApprovalConditionId: number, request: UpdateMinuteApprovalConditionRequest) :Observable<ActionResponseDTO<MinuteRequestApprovalRuleConditionDTO>>{
    const endpoint = `${environment.apiUrl}/MinuteApprovalRules/${minuteRequestApprovalRuleId}/conditions/${minuteRequestApprovalConditionId}`;
    return this.httpClient.put<ActionResponseDTO<MinuteRequestApprovalRuleConditionDTO>>(endpoint, request);
  }

  public addMinuteRequestApprovalConditions(minuteRequestApprovalRuleId: number, conditions: AddUpdateApprovalMinuteConditionDTO[]): Observable<ActionResponseDTO<number>>{
    const endpoint = `${environment.apiUrl}/MinuteApprovalRules/${minuteRequestApprovalRuleId}/conditions`;
    return this.httpClient.post<ActionResponseDTO<number>>(endpoint, conditions);
  }
}
